import { Routes, Route } from '@angular/router';
import { Injectable } from '@angular/core';
import { Toaster } from 'ngx-toast-notifications';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { NgxImageCompressService } from 'ngx-image-compress';
/*import 'ng2-toasty/style-default.css';
import 'ng2-toasty/style-bootstrap.css';
import 'ng2-toasty/style-material.css';
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty'; */

@Injectable({
    providedIn: 'root'
})
export class Main {

    baseApi: string;

    sizeOfOriginalImage: number;
    sizeOFCompressedImage: number;
    imgResultBeforeCompress: string;
    imgResultAfterCompress: string;
    localCompressedURl: any;

    constructor(private toaster: Toaster, private httpClient: HttpClient,
        private imageCompress: NgxImageCompressService,/* , private toastyService: ToastyService */) {
        this.baseApi = environment.production
            ? environment.ONLINE_BASE_URL.substring(0, environment.ONLINE_BASE_URL.length - 4) :
            environment.LOCAL_BASE_URL.substring(0, environment.LOCAL_BASE_URL.length - 4);
    }

    toast(data: any) {
        this.toaster.open({
            text: data.body,
            //fontsize:10,
            caption: data.title,
            type: data.type,
            position: 'top-right',
            duration: 3000,
        });
    }


    public upload(data) {
        debugger;
        let uploadURL = `${this.baseApi}api/assets`;
        return this.httpClient.post<any>(uploadURL, data, {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('access_token') },
            reportProgress: true,
            observe: 'events'
        }).pipe(map((event) => {
            switch (event.type) {
                case HttpEventType.UploadProgress:
                    const progress = Math.round(100 * event.loaded / event.total);
                    return { status: 'progress', message: progress };
                case HttpEventType.Response:
                    return event.body;
                default:
                    //return `Unhandled event: ${event.type}`;
                    return {
                        status: 'unhandeled event', message: `${event.type}`
                    };
            }
        })
        ).toPromise();
    }



    async compressFile(image: any, fileName: string) {
        debugger;
        var temp = [];
        var orientation = -1;
        this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
        // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
        await this.imageCompress.compressFile(image, orientation, 50, 50).then(
            result => {
                debugger;
                this.imgResultAfterCompress = result;
                this.localCompressedURl = result;
                this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
                // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
                const imageName = fileName;
                const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
                const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
                temp.push(imageFile);
            });
        return temp;

    }

    dataURItoBlob(dataURI: any) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        return blob;
    }


    /*   public addToast(type: any, statusText: any) {
          let toastOptions: ToastOptions = {
              title: type,
              msg: statusText,
              showClose: true,
              timeout: 5000,
              theme: 'default',
          };
          switch (type) {
              case 'Info':
                  this.toastyService.info(toastOptions);
                  break;
              case 'Success':
                  this.toastyService.success(toastOptions);
                  break;
              case 'Wait':
                  this.toastyService.wait(toastOptions);
                  break;
              case 'Error':
                  this.toastyService.error(toastOptions);
                  break;
              case 'Warning':
                  this.toastyService.warning(toastOptions);
                  break;
          }
  
      } */

      getIntervalFormalStr(interval: String) {
        switch (interval) {
          case 'weekly':
            return 'weeks';
          case 'monthly':
            return 'months';
          case 'daily':
            return 'days';
        }
      }

}
